<!-- =========================================================================================
    File Name: TheFooter.vue
    Description: Footer component
    Component Name: TheFooter
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <footer class="the-footer flex-wrap justify-between" :class="classes">
    <span
      >COPYRIGHT &copy; {{ new Date().getFullYear() }}
      <a href="http://eurcd.com" target="_blank" rel="nofollow">成都欧城记</a>
      版权所有
      <span style="margin-left: 10px; cursor: pointer" @click="openUrl"
        >蜀ICP备18009933号-1</span
      >
    </span>
    <!-- <span class="md:flex hidden items-center">
      <span>Hand-crafted & Made with</span>
      <feather-icon icon="HeartIcon" svgClasses="stroke-current text-danger w-6 h-6" class="ml-2" />
    </span> -->
  </footer>
</template>

<script>
export default {
  name: 'the-footer',
  props: {
    classes: {
      type: String,
    },
  },
  methods: {
    //跳转ICP/IP地址/域名信息备案管理系统
    openUrl() {
      window.open('https://beian.miit.gov.cn', '_blank')
    },
  },
}
</script>
